import React from 'react';
import { AppThunk } from '..';
import { UPDATE_FLASH_MESSAGE, RESET_FLASH_MESSAGE } from '../actionTypes';
import { dispatchReduxError } from '../../utils/dispatchReduxError';

type Payload = {
  open: boolean;
  severity: 'success' | 'info' | 'warning' | 'error';
  message: string;
  icon?: React.ReactNode | undefined;
  primaryAction?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
};

export const updateFlashMessage =
  (payload: Payload): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: UPDATE_FLASH_MESSAGE, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const resetFlashMessage = (): AppThunk => async dispatch => {
  try {
    dispatch({ type: RESET_FLASH_MESSAGE });
  } catch (error) {
    dispatchReduxError(dispatch);
  }
};
